import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) =>
  (listingId: number, hash: string, lang?: string) =>
    makeCall<undefined>(
      'GET',
      `/api/v2/listing/${listingId}/calendar/${hash}`,
      {
        query: { lang },
      },
    );
